<template>
  <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 0px; ">
    <el-form :inline="true" @submit.native.prevent>
      <el-radio-group v-model="busLinesId" @change="btnClick($event,'busLinesId')" size="medium" style="float:left;margin-right: 20px;">
        <el-radio-button 
          v-for="item in busLinesList"
          :key="item.id"
          :label="item.id">
          {{ item.lineName }}
        </el-radio-button>
      </el-radio-group>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="item.Func&&(item.Func.toLowerCase().indexOf('handledel')!= -1 ||item.Func.toLowerCase().indexOf('stop')!= -1 )? 'danger':'primary'" v-if="!item.IsHide" @click="callFunc(item)">{{item.name}}</el-button>
      </el-form-item>
    </el-form>
  </el-col>
</template>
<script>
import { getBusLinesListPage } from "../../api/api";

export default {
  name: "SchedulingTemplateToolbar",
  data() {
    return {
      busLinesList: [], //线路列表
      busLinesId:"" //线路ID
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      let itemExt = {};
      if(item !== null){
        itemExt = item;
      }
      itemExt.busLinesId = this.busLinesId;
      this.$emit("callFunction", itemExt); //将值传给父组件
    },   
    getBusLinesList(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLinesList = [];
        this.busLinesId = '';
        if(res.data.response.dataCount > 0){
          for (let i = 0; i < res.data.response.dataCount; i++) {
            let busLinesDataObj = {};
            busLinesDataObj.id = res.data.response.data[i].Id;
            busLinesDataObj.type = i===0?'primary':'';
            busLinesDataObj.lineName = res.data.response.data[i].LineChineseName;
            this.busLinesList.push(busLinesDataObj);
            if(i===0){
              this.busLinesId = busLinesDataObj.id;
            }
          }
        }
      });
    },
    btnClick(value,type){ 
  
      if(type === "departureDate"){
        this.departureDate = value;
      } else if(type === "departureDatePicker"){
        this.departureDate = formatDate(value);
      } else{
        this.busLinesId = value;
      }
      this.callFunc(null);
   
    },
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLinesList(pageSizePara);    
  },
 
    
};
</script>